import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailCyclesRPC } from "./getEmailCyclesRPC";

export class GetEmailCyclesRPCClientImpl extends GetEmailCyclesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailCyclesRPC.Request): Promise<LeoRPCResult<GetEmailCyclesRPC.Response, GetEmailCyclesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailCycles",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailCyclesRPC.ResponseDTO,
      GetEmailCyclesRPC.Errors.ErrorsDTO,
      GetEmailCyclesRPC.Response,
      GetEmailCyclesRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailCycles",
      GetEmailCyclesRPC.Response.fromDTO,
      GetEmailCyclesRPC.Errors.fromDTO
    );
  }
}
